import { getImageDirectUploadData } from '../../../../utils/getImageDirectUploadData'
import type { FormValues } from '../../types'
import { getCommonFieldsPayload } from './getCommonFieldsPayload'

export const getVideoEmbedPostPayload = async (values: FormValues) => {
  const payload = getCommonFieldsPayload(values)

  return {
    ...payload,
    attributes: {
      core: payload.attributes.core,
      series: values.videoSeries,
    },
    embed: {
      url: values.videoUrl as any,
    },
    imageDirectUploadData:
      typeof values.videoThumbnail === 'object'
        ? await getImageDirectUploadData(values.videoThumbnail as File)
        : undefined,
    remove_thumbnail: values.videoThumbnail === undefined,
  }
}
